import { useState } from 'react';
import { usePermissions } from '../../auth/session.tsx';
import { useIsScopedMember } from '../../api/org.ts';
import { BroadcastIcon } from './BroadcastIcon.tsx';
import { BroadcastModal } from './BroadcastModal.tsx';

/**
 * The header "Broadcast" affordance: opens the org-wide takeover composer.
 * Hidden entirely for viewers (they can't mutate anything); shown but disabled
 * with an explanatory tooltip for scoped editors (a broadcast is org-wide, which
 * their access doesn't cover — the API also rejects it with 403). Everyone else
 * gets the live button.
 */
export function BroadcastLauncher() {
  const { isViewer } = usePermissions();
  const scoped = useIsScopedMember();
  const [open, setOpen] = useState(false);

  if (isViewer) return null;

  if (scoped) {
    return (
      <span
        className="bcast-launch-wrap"
        title="Org-wide broadcast requires full access"
      >
        <button
          type="button"
          className="btn ghost sm bcast-launch"
          disabled
          aria-disabled="true"
          aria-label="Broadcast"
        >
          <span className="ico" aria-hidden>
            <BroadcastIcon />
          </span>
          <span className="bcast-launch-label">Broadcast</span>
        </button>
      </span>
    );
  }

  return (
    <>
      <button
        type="button"
        className="btn ghost sm bcast-launch"
        onClick={() => setOpen(true)}
        aria-label="Broadcast"
      >
        <span className="ico" aria-hidden>
          <BroadcastIcon />
        </span>
        <span className="bcast-launch-label">Broadcast</span>
      </button>
      {open && <BroadcastModal onClose={() => setOpen(false)} />}
    </>
  );
}
